export const authToken = (
  document.getElementById("root") as HTMLInputElement
).getAttribute("authToken");

export const quizId = Number(
  (document.getElementById("root") as HTMLInputElement).getAttribute("quizId")
);
export const quizType = (
  document.getElementById("root") as HTMLInputElement
).getAttribute("quizType");
export const userId = (
  document.getElementById("root") as HTMLInputElement
).getAttribute("userId");
export const userName = (
  document.getElementById("root") as HTMLInputElement
).getAttribute("userName");
export const email = (
  document.getElementById("root") as HTMLInputElement
).getAttribute("email");

export const deleteOldQuiz = (
  document.getElementById("root") as HTMLInputElement
).getAttribute("deleteOldQuiz");

export const sendEmail = (
  document.getElementById("root") as HTMLInputElement
).getAttribute("sendEmail");

export const confirmBoxTitle = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("confirmBoxTitle");
export const confirmBoxDesc = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("confirmBoxDesc");
export const startQuizTitle = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("startQuizButtonText");
export const resumeQuizTitle = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("resumeQuizButtonText");
export const flagLaterText = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("flagLaterButtonText");
export const unFlagText = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("unFlagButtonText");
export const saveButtonText = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("saveButtonText");
export const checkButtonText = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("checkButtonText");
export const finishButtonText = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("finishButtonText");
export const nextButtonText = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("nextButtonText");
export const attemptsLeftText = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("attemptsLeftText");
export const correctSoundUrl = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("correctAnswerSound");
export const inCorrectSoundUrl = (
  document.getElementById("language-values") as HTMLInputElement
).getAttribute("inCorrectAnswerSound");

export const symbolTable = [
  { symbol: "+", title: "" },
  { symbol: "-", title: "" },
  { symbol: "/", title: "" },
  { symbol: "!", title: "" },
  { symbol: "*", title: "" },
  { symbol: "%", title: "" },
  { symbol: "≥", title: "" },
  { symbol: "<", title: "" },
  { symbol: "=", title: "" },
];
